
import {Component, Prop, Vue, Inject} from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'service-item-input',
  components: ServiceContainer().getComponents(),
})

export default class ProductServices extends Vue {
  @Prop({required: true}) readonly service: object;

  @Inject('serviceQuoteItemId') readonly quoteItemId: number;
  @Inject('serviceProductSku') readonly productSku: string;
  @Inject('serviceIndex') readonly index: number;
  @Inject('serviceQuoteAutoRun') readonly quoteAutoRun: boolean;

  private modal: boolean = false;

  private get selectedProductServices(): boolean {
    return this.$store.getters['ProductServices/selectedProductServices'][this.index][this.productSku].hasOwnProperty(this.service['sku']);
  }

  private set selectedProductServices(value) {
    this.$store.commit('ProductServices/ADD_SELECTED_PRODUCT_SERVICES', {
      value: value || value == null,
      productSku: this.productSku,
      service: this.service,
      hasChildren: this.service.hasOwnProperty('children'),
      serviceType: this.service['option_group'] ? 'radio' : 'checkbox',
      index: this.index
    });

    if ( ! this.quoteAutoRun) {
      return;
    }

    this.addServiceToQuote({
      cartItemId: this.quoteItemId,
      productSku: this.productSku,
      index: this.index,
    });
  }

  private async addServiceToQuote(servicesData: object): Promise<void> {
    this.$store.commit('CheckoutTotals/APPEND_ITEM_PENDING_CHANGES', this.quoteItemId);
    await this.$store.dispatch('ProductServices/addServiceToQuote', servicesData);
    this.$store.commit('CheckoutTotals/REMOVE_ITEM_PENDING_CHANGES', this.quoteItemId);

    await this.$store.dispatch('CheckoutTotals/fetchCartTotals');
  }

  private created(): void {
    document.addEventListener('keydown', this.checkKey);
  }

  private get getId(): string {
    return this.quoteItemId ?
        `${this.productSku}-${this.service['sku']}-${this.quoteItemId}` :
        `${this.productSku}-${this.service['sku']}`;
  }

  private get getName(): string {
    return this.quoteItemId ?
        `${this.service['option_group'] || 'parent'}-${this.quoteItemId}` :
        `${this.service['option_group'] || 'parent'}`;
  }

  private checkKey(e): void {
    if ( ! this.modal) return;

    e = e || window.event;
    if (e.which === 27 || e.keyCode === 27) {
      this.closeModal();
    }
  }

  private closeModal(): void {
    this.modal = false;
    document.body.classList.remove('no-scrolling');
  }

  private toggleModal(): void {
    this.modal = ! this.modal;
    document.body.classList.toggle('no-scrolling');
  }
}
